<div class="edit-screen">

  <app-storyboard-edit-header *ngIf="item" [storyboard]="item"></app-storyboard-edit-header>

  <split direction="vertical">

    <split-area [size]="60" class="preview-area d-flex">
      <app-preview *ngIf="item" [storyboard]="item"></app-preview>
    </split-area>
    <split-area [size]="40" class="timeline-area">
      <app-timeline *ngIf="item" class="timeline-container" [storyboard]="item"></app-timeline>
    </split-area>
  </split>

</div>



// WEBPACK FOOTER //
// ./src/app/template/template-edit/template-edit.component.html